<template>
  <div>
    <div class="row justify-content-center mb-2">
      <button class="btn btn-add" id="v-step-0" @click="startTour">
        Iniciar Tour
      </button>
    </div>
    <div class="row justify-content-center" id="v-step-1"></div>
    <v-tour name="myTour" :steps="steps">
      <template slot-scope="tour">
        <transition name="fade">
          <v-step
            v-if="tour.currentStep === index"
            v-for="(step1, index) of tour.steps"
            :key="index"
            :step="step1"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :skip="tour.skip"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels"
          >
            <template>
              <div slot="actions">
                <button
                  v-if="tour.currentStep != 0"
                  @click="tour.previousStep"
                  class="btn-step-back"
                >
                  Anterior
                </button>
                <button
                  @click="cancelTour(tour.currentStep)"
                  class="btn-step-back"
                >
                  Pular tour
                </button>
                <button
                  @click="
                    nextTour(
                      tour.currentStep,
                      tour.steps[index + 1],
                      tour.steps[index]
                    )
                  "
                  v-if="tour.currentStep != 1"
                  class="btn-step"
                >
                  Próximo
                </button>
                <button
                  @click="cancelTour(tour.currentStep)"
                  v-else
                  class="btn-step"
                >
                  Finalizar
                </button>
              </div>
            </template>
          </v-step>
        </transition>
      </template>
    </v-tour>
    <base-crud
      crudName="Empresas"
      newText="Nova Empresa"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="isInnovaretiUser()"
      :enableEdit="true"
      :enableDelete="isInnovaretiUser()"
      :enableView="false"
      :dataForm="dataForm"
    />
  </div>
</template>
<script>
import BaseCrud from "../Base/BaseCrud";
export default {
  data: function () {
    return {
      steps: [
        {
          target: "#v-step-0", // We're using document.querySelector() under the hood
          header: {
            title: "Tela de Empresa!",
          },
          params: {
            enableScrolling: false,
          },
          content: `Clique em <strong>próximo</strong> para continuar no tour. Caso não queira esse acompanhamento, clique em <strong>Pular tour</strong>. Se preferir poderá ver esse tour guiado a qualquer momento no botão destacado no menu superior.`,
        },
        {
          target: "#v-step-1",
          params: {
            enableScrolling: false,
          },
          content:
            "Em Empresas é somente possível editar a sua empresa e não criar uma nova, para editar basta clicar em <i class='fas fa-pencil-alt'></i>.",
        },
      ],
      table: "companies",
      // pages: [],
      // url: '',
      columns: [
        "id",
        "company_name",
        "company_name_fantasy",
        "email",
        "city",
        "state",
        "status",
        "actions",
      ],
      tableData: [
        "id",
        "company_name",
        "company_name_fantasy",
        "email",
        "city",
        "state",
        "status",
      ],
      options: {
        filterable: [
          "id",
          "company_name",
          "company_name_fantasy",
          "email",
          "city",
          "state",
        ],

        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        filterByColumn: true,
        debounce: 1000,
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          company_name: "Razão Social",
          company_name_fantasy: "Nome Fantasia",
          email: "E-mail",
          city: "Cidade",
          state: "Estado",
          status: "Status",
          actions: "Ações",
        },
        templates: {
          status: function(h, row) {
            return row.status == 1 ? 'Ativo' : 'Inativo';
          }
        },
        requestFunction: function (data) {
          let requestData = {};
          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [""];
          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "companies/",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    isInnovaretiUser(){
      return this.$store.state.user.email && this.$store.state.user.email.includes('@innovareti.com.br');
    },
    cancelTour(step) {
      const self = this;
      self.$tours["myTour"].skip();
      self.$store.commit("skipTour");

      let data = { finished_step: step };

      const api = self.$store.state.api + "user/finish-tour";

      self.$http.post(api, data).then((response) => {});
    },
    nextTour(step, actual_target, previous_target) {
      const self = this;

      if (step >= 31) {
        if (step >= 31) {
          $(previous_target.target).toggleClass("activeMenu");
        }
        $(actual_target.target).toggleClass("activeMenu");
      }

      if (step == 1) {
        $("#sidebar").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#pagCads").toggleClass("active");
        setTimeout(function () {
          self.$tours["myTour"].nextStep();
        }, 500);
      } else if (step == 31) {
        $("#sidebar").toggleClass("active");
        $("html, body").animate({ scrollTop: 0 }, 0);
        self.$tours["myTour"].nextStep();
      } else {
        self.$tours["myTour"].nextStep();
      }
    },
    startTour() {
      let self = this;
      self.$tours["myTour"].start();
    },
    query: function (query) {
      let columns = {
        id: "id",
        company_name: "company_name",
        email: "email",
        city: "city",
        state: "state",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>
<style scoped>
.VuePagination {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/Company/Crud.vue